<template>
  <div class="backStack-issue-wrap informationCreate">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit(0)">保存</a-button>
        <a-button class="submit-audit" @click="toAudit(1)">保存并发布</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import { formRules, formRows } from './configs/formOptions.js'
import { addTeamInfo } from '@/api/talentsInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: true,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {},
      isRead: false
    }
  },
  components: {
    From
  },
  methods: {
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    async toAudit(status) {
      this.$refs.formRef.validatedForm(async () => {
        try {
          const { picPath, ...formValue } = this.$refs.formRef.formModel
          const pic = this.handlerPicPathIds(picPath).join(',')
          const params = {
            ...formValue,
            pic,
            status
          }

          const { msg, code } = await addTeamInfo(params)
          this.$apiStatusHandler(code, msg)
          if (code === 200) {
            this.$router.push('/talents/techTeam')
          }
        } catch (error) {
          this.$apiStatusHandler(99, error)
        }
      })
    },
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        const { fileId } = item.response.data[0]
        pre.push(fileId)
        return pre
      }, [])
    }
  }
}
</script>
